import { useMemo } from 'react';
import { HYDROCARBON_TYPES } from '@/utils/constants';
import type {
  HydrocarbonFilter,
  ValuationsFilters as ValuationsFiltersType,
} from '../../store/valuationsStore';
import { AutoCompleteSimpleComposable } from './AutoCompleteSimpleComposable';

type HydrocarbonsProps = {
  filters: ValuationsFiltersType;
  onChange: (hydrocarbons: HydrocarbonFilter[]) => void;
};

const name = 'Hydrocarbon';

export const HydrocarbonsFilter = ({ filters, onChange }: HydrocarbonsProps) => {
  const hydrocarbons = HYDROCARBON_TYPES;

  const hydrocarbonsValue = useMemo(() => {
    const filterHydrocarbons = filters.hydrocarbons;
    if (Array.isArray(filterHydrocarbons)) {
      return filterHydrocarbons;
    }
    if (filterHydrocarbons && typeof filterHydrocarbons === 'object') {
      return [filterHydrocarbons];
    }
    return [];
  }, [filters.hydrocarbons]);

  return (
    <AutoCompleteSimpleComposable<HydrocarbonFilter>
      options={hydrocarbons}
      loading={false}
      value={hydrocarbonsValue}
      multiple={true}
      size='medium'
      getOptionLabel={option => (typeof option === 'string' ? option : option.name || '')}
      onChange={(_, newValue) => {
        onChange((newValue as HydrocarbonFilter[]) || []);
      }}
      renderInput={params => (
        <AutoCompleteSimpleComposable.StyledInput
          params={params}
          label={name}
          data-id='hydrocarbons-filter-input'
        />
      )}
      renderTags={(value, getTagProps) => {
        const numTags = value.length;
        return (
          <>
            {value.slice(0, 1).map((option, index) => (
              <AutoCompleteSimpleComposable.StyledTag
                key={option.id || option.name || index}
                option={option}
                index={index}
                getTagProps={getTagProps}
                getOptionLabel={opt => opt.name || ''}
              />
            ))}
            {numTags > 1 && ` +${numTags - 1}`}
          </>
        );
      }}
      renderOption={(props, option, state) => {
        return (
          <AutoCompleteSimpleComposable.Option
            {...props}
            option={option}
            state={state}
            getOptionLabel={opt => opt.name || ''}
          />
        );
      }}
      data-id='hydrocarbons-filter'
    />
  );
};
